export const POST_FOREIGN_INVESTOR_PROVIDE_DETAILS_REQUEST =
  'auth.register.onfido.POST_FOREIGN_INVESTOR_PROVIDE_DETAILS_REQUEST'
export const POST_FOREIGN_INVESTOR_PROVIDE_DETAILS_SUCCESS =
  'auth.register.onfido.POST_FOREIGN_INVESTOR_PROVIDE_DETAILS_SUCCESS'
export const POST_FOREIGN_INVESTOR_PROVIDE_DETAILS_FAILURE =
  'auth.register.onfido.POST_FOREIGN_INVESTOR_PROVIDE_DETAILS_FAILURE'
